import { Drawer, DrawerProps } from 'antd';
import { DrawerStyles } from 'antd/es/drawer/DrawerPanel';
import { ReactNode, PropsWithChildren } from 'react';

import { GraphSetSidebarPlacement } from 'business/data-analysis/pages/graph/components/graph-set-side-bar';

import './index.scss';

interface Props extends Omit<DrawerProps, 'className'> {
  title: ReactNode;
  onClose: () => void;
  footer?: ReactNode;
  styles?: DrawerStyles;
  placement?: GraphSetSidebarPlacement;
  closable?: boolean;
}

export const CapSidebar = (props: PropsWithChildren<Props>) => {
  return <Drawer {...props} className="drawer-sidebar"></Drawer>;
};
